<div class="modal-header-title">
    <div class="title">
        {{title}}
    </div>

    <span class="close-modal" (click)="closeOpenModal()">
        <mat-icon svgIcon="e-close"></mat-icon>
    </span>
</div>
